<ng-container *hasPermission="['READ', 'device']">
  <div id="dash-map" [routerLink]="['/map']">
    <div id="transparent-filter">
      @if ($filters()?.devices || $filters()?.landmarks) {
        <div class="filter-container">
          <!-- TODO: make it a generic component -->
          <mat-icon>info</mat-icon>
          <span class="filter-container-text">
            <p>
              {{ 'MAP.FILTERS_MESSAGE' | translate }}
              @if ($filters()?.devices) {
                {{ 'MAP.FILTERS_DEVICES' | translate }}
              }
              @if ($filters()?.devices && $filters()?.landmarks) {
                {{ 'COMMON.AND' | translate }}
              }
              @if ($filters()?.landmarks) {
                {{ 'MAP.FILTERS_LANDMARKS' | translate }}
              }
            </p>
          </span>
        </div>
      }
    </div>
  </div>
</ng-container>
@if (!permissionService.checkPermissionValue({ permission: 'READ', tab: 'device' })) {
  <div class="container-allowed">
    <p class="not-allowed-text">
      {{ 'USER.NOT_ACCESS_DATA' | translate }}
      <br />
      {{ 'USER.PLEASECONTACTADMIN' | translate }}
    </p>
  </div>
}
